import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { useLocation } from 'react-router-dom';
import {
  getCookieConsent,
  setCookieConsent,
  startYandexMetrika,
  trackYandexPageview,
} from '../utils/yandexMetrika';

const CookieConsentBanner = () => {
  const location = useLocation();
  const [consent, setConsent] = useState(getCookieConsent);

  useEffect(() => {
    if (consent !== 'accepted') return;
    const pageUrl = `${window.location.origin}${location.pathname}${location.search}${location.hash}`;
    startYandexMetrika(pageUrl);
    trackYandexPageview(pageUrl);
  }, [consent, location.pathname, location.search, location.hash]);

  const choose = (value) => {
    setCookieConsent(value);
    setConsent(value);
  };

  if (consent || location.pathname === '/token_pricing') return null;

  return createPortal(
    <div className="fixed inset-x-0 bottom-0 z-[1400] p-3 sm:p-5">
      <div
        className="mx-auto flex max-w-3xl flex-col gap-3 rounded-2xl border border-slate-200 bg-white p-4 shadow-2xl sm:flex-row sm:items-center sm:gap-5"
        role="dialog"
        aria-labelledby="cookie-consent-title"
        aria-describedby="cookie-consent-text"
      >
        <div className="min-w-0 flex-1">
          <p id="cookie-consent-title" className="text-sm font-semibold text-slate-900">
            Мы используем cookie
          </p>
          <p id="cookie-consent-text" className="mt-1 text-sm leading-5 text-slate-600">
            На портале, включая страницы входа и регистрации, cookie сервиса Яндекс.Метрика
            подключаются только после вашего согласия. Если вы откажетесь, счётчик не запустится.{' '}
            <a
              className="font-medium text-brand-600 underline decoration-brand-200 underline-offset-2 hover:text-brand-700"
              href="https://onlanta.ai/cookie"
              target="_blank"
              rel="noopener noreferrer"
            >
              Подробнее о cookie
            </a>
          </p>
        </div>
        <div className="flex shrink-0 gap-2">
          <button
            type="button"
            className="h-10 rounded-xl border border-slate-300 bg-white px-4 text-sm font-semibold text-slate-700 transition hover:bg-slate-50"
            onClick={() => choose('declined')}
          >
            Отклонить
          </button>
          <button
            type="button"
            className="h-10 rounded-xl bg-brand-600 px-4 text-sm font-semibold text-white transition hover:bg-brand-700"
            onClick={() => choose('accepted')}
          >
            Принять
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default CookieConsentBanner;
